const key = 'device'
export default key
